import { render, staticRenderFns } from "./ProfileActivities.vue?vue&type=template&id=a9611e1a&"
import script from "./ProfileActivities.vue?vue&type=script&lang=js&"
export * from "./ProfileActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports